export default __webpack_public_path__ + "static/media/Mark-3-HUD-3D (Environmental Scan).ec22ba27.jpg";